import React, { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { Rss, Plus, LogOut, X } from 'lucide-react';
import { AddSourceForm } from '@/components/AddSourceForm';
import { SourceList } from '@/components/SourceList';

export default function Sidebar({ sources, loadingSources, onAddSource, onDeleteSource, onCloseMobile }) {
  const { logout } = useAuth();
  const [showAddForm, setShowAddForm] = useState(false);

  return (
    <div className="w-80 h-screen bg-white border-r-2 border-black flex flex-col overflow-hidden">
      {/* Header */}
      <div className="p-6 border-b-2 border-black flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Rss strokeWidth={2.5} size={24} className="text-pink-500" />
          <h1 className="text-xl font-black tracking-tight uppercase">FEEDBOX</h1>
        </div>
        <button data-testid="mobile-close-button" className="lg:hidden" onClick={onCloseMobile}>
          <X strokeWidth={2.5} size={20} />
        </button>
      </div>

      {/* Add source section */}
      <div className="p-4 border-b-2 border-black">
        {showAddForm ? (
          <AddSourceForm
            onAddSource={onAddSource}
            onCancel={() => setShowAddForm(false)}
          />
        ) : (
          <button
            data-testid="show-add-source-button"
            onClick={() => setShowAddForm(true)}
            className="brutalist-btn-primary w-full flex items-center justify-center gap-2 text-sm"
          >
            <Plus strokeWidth={2.5} size={16} />
            Add Source
          </button>
        )}
      </div>

      {/* Source list */}
      <div className="flex-1 overflow-y-auto p-4">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-3 block">
          Your Sources ({sources.length})
        </span>
        <SourceList sources={sources} loading={loadingSources} onDeleteSource={onDeleteSource} />
      </div>

      {/* Logout */}
      <div className="p-4 border-t-2 border-black">
        <button
          data-testid="logout-button"
          onClick={logout}
          className="w-full flex items-center justify-center gap-2 p-3 text-sm font-bold uppercase border-2 border-transparent hover:border-black hover:bg-pink-100 transition-all"
        >
          <LogOut strokeWidth={2.5} size={16} />
          Sign Out
        </button>
      </div>
    </div>
  );
}
